import { render, staticRenderFns } from "./ImageSelect.vue?vue&type=template&id=2472dc3d"
import script from "./ImageSelect.vue?vue&type=script&lang=js"
export * from "./ImageSelect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports